import ApiGenericServicesData from "service/ApiGenericServicesData";
import { codificarValorSeguro } from "util/codificarValorSeguro";

export default class SolicitudHojasAfiliacion extends ApiGenericServicesData {
    constructor() {
        super("solicitudHojasAfiliacion");
    }

    async createRequest(data) {
        const dataSegura = await codificarValorSeguro(data);
        return this.customPOST("create", dataSegura);
    }

    async openFile(CVE, ruta) {
        const rutaSegura = await codificarValorSeguro(ruta);
        const CVESeguro = await codificarValorSeguro(CVE);
        return this.customGET("openFile/" + rutaSegura + "/" + CVESeguro);
    }

    listFilter() {
        return this.customGET("listFilter/");
    }
}
